import * as THREE from "three";

export class CameraShake {
  private offset = new THREE.Vector3();
  private intensity = 0;
  private maxOffset = 0.25;

  setIntensity(value: number): void {
    this.intensity = Math.max(0, value);
  }

  setMaxOffset(value: number): void {
    this.maxOffset = Math.max(0, value);
  }

  apply(camera: THREE.Camera, intensity?: number): void {
    if (typeof intensity === "number") this.intensity = Math.max(0, intensity);
    if (this.intensity <= 0) {
      camera.position.sub(this.offset);
      this.offset.set(0, 0, 0);
      return;
    }
    camera.position.sub(this.offset);
    const amp = Math.min(this.intensity, this.maxOffset);
    this.offset.set(
      (Math.random() - 0.5) * 2 * amp,
      (Math.random() - 0.5) * 2 * amp,
      0
    );
    camera.position.add(this.offset);
  }

  reset(camera?: THREE.Camera): void {
    if (camera) camera.position.sub(this.offset);
    this.offset.set(0, 0, 0);
    this.intensity = 0;
  }
}
